module.exports = __webpack_public_path__ + "static/media/sidebar-account-manager-active.53178b5b.svg";